
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/books/[id]",
      function () {
        return require("private-next-pages/books/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/books/[id]"])
      });
    }
  